"use strict";

module.exports = require("./cjs/ost.wechat.cjs.js");
